import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { RedirectService } from '../redirect/redirect.service';
import { UserGuideService } from './user-guide.service';
import { CapabilityEngineService } from '../capabilityEngine.service';
@Component({
    selector: 'app-user-guide',
    templateUrl: './user-guide.component.html',
    styleUrls: ['./user-guide.component.scss']
})
export class UserGuideComponent implements OnInit {

    firstImage = undefined;
    imageList = [];
    dataList = [];
    indexCount = 0;
    firstImageDescription: string;

    footerDescription = '';
    currentTabIndex = 0; // Count starts from 0;

    // tslint:disable-next-line:no-empty
    constructor(
        private _userGuideService: UserGuideService,
        private _activatedRoute: ActivatedRoute,
        private _redirectService: RedirectService,
        private _router: Router,
        private _capabilityEngineService :CapabilityEngineService
    ) { }

    ngOnInit() {

        this.firstImage = 'assets/images/create-form-templates-1.png'; // Index - 0
        this.firstImageDescription = 'Add Form Template';
        this.footerDescription =  this.firstImageDescription;

        this.dataList = [
            { imageUrl: 'assets/images/create-form-templates-2.png', tab: 0, description: 'Drag and drop fields, apply properties as needed and Submit it' }, // 1
            { imageUrl: 'assets/images/create-form-templates-3.png', tab: 0, description: 'Form Template is ready. Navigate to the details view and click on the template you created.' }, // 2
            { imageUrl: 'assets/images/create-form-templates-4.png', tab: 0, description: 'Publish it to show it on the mobile app.' }, // 3
            { imageUrl: 'assets/images/download-mobile-app.png', tab: 1, description: 'Download the app from the App Store/Google Play.' }, // 4
            { imageUrl: 'assets/images/fill-submit-form.png', tab: 2, description: 'Find the relevant Form Template & Add Form. Fill Form & Submit it' }, // 5
            { imageUrl: 'assets/images/fix-hazard-1.png', tab: 3, description: 'Add Form Template with Hazard field.Submit inspection with a Hazard.' }, // 6
            { imageUrl: 'assets/images/fix-hazard-2.png', tab: 3, description: 'Hazards along with their status are accessible to all users via the mobile & web.' }, // 7
            // { imageUrl: 'assets/images/product-mockup.png', tab: 3, description: 'Hazars along with their status are accessible to all users via the mobile & web.' } // 9
        ];

        _.forEach(this.dataList, (dataObj, index) => {
            this.imageList.push(dataObj.imageUrl);
        });
    }

    tabClick(newImageIndexValue) {
        this.indexCount = newImageIndexValue;
        this.updateChanges();
    }

    previousClick() {
        this.indexCount--;
        this.updateChanges();
    }

    nextClick() {
        this.indexCount++;
        this.updateChanges();
    }
    canPerform(data) {
        return this._capabilityEngineService.canPerform(data);
    }
    updateChanges() {
        // console.log(this.indexCount);
        // console.log(this.indexCount,this.footerDescription,this.dataList[this.indexCount]);
        if (this.indexCount === 0) {
            this.footerDescription = this.firstImageDescription;
            this.currentTabIndex = 0;
        } else {
            this.footerDescription = this.dataList[this.indexCount - 1].description;
            this.currentTabIndex = this.dataList[this.indexCount - 1].tab;
        }
    }

    finishGuide() {
        const dataObj = {
            type: 'WEB',
            tutorial: 0
        };
        this.navigateTo(dataObj);
        // if(this.canPerform(['forceUpdate']) || this.canPerform(['viewTeamList'])){
        //     this._router.navigateByUrl('/teamsList'); 
        // }
        if(this.canPerform(['forceUpdate']) || this.canPerform(['viewTeamList'])){
            this._router.navigateByUrl('/teamsList'); 
        }
    }

    skipGuide() {
        const dataObj = {
            type: 'WEB',
            tutorial: 2
        };
        this.navigateTo(dataObj);
    }

    navigateTo(dataObj) {
        if (!this._activatedRoute.snapshot.queryParams.id) {
            this._userGuideService.updateTutorialSetting(dataObj)
                .subscribe((result: any) => {
                   this._router.navigateByUrl('/formsList');
                },
                    (err) => {
                        console.log('err ', err);
                    });
        }else if(this.canPerform(['forceUpdate']) || this.canPerform(['viewTeamList'])){
            this._router.navigateByUrl('/teamsList'); 
        }
         else {
           this._router.navigateByUrl('/formsList');
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/user-guide/user-guide.component.ts